import React, { memo, useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import Logo from "../Logo";
import RegisterModal from "../Auth/RegisterModal";
import Marquee from "../Marquee";
import styles from "./Header.module.css";
import { useSelector } from "react-redux";

const Header = memo(({ onLoginClick, onContactClick }) => {
  const [isRegisterOpen, setRegisterOpen] = useState(false);
  const currentUser = useSelector((state) => state.user.currentUser);
  const navigate = useNavigate();

  const handleLogin = useCallback(() => {
    onLoginClick();
  }, [onLoginClick]);

  const handleRegister = useCallback(() => {
    setRegisterOpen(true);
  }, []);

  const handleLogoClick = useCallback(() => {
    navigate("/home");
  }, [navigate]);

  const closeRegister = useCallback(() => setRegisterOpen(false), []);

  return (
    <header className={styles.header}>
      <div className={styles.topBar}>
        <div className={styles.container}>
          <div className={styles.leftSection}>
            <div className={styles.logoWrapper}>
              <button
                type="button"
                className={styles.logoButton}
                onClick={handleLogoClick}
                aria-label="Go to home"
              >
                <Logo />
              </button>
            </div>
          </div>

          <div className={styles.center2Section}>
            {!currentUser && (
              <div className={styles.authSection}>
                <div className={styles.authButtons}>
                  <button className={styles.loginBtn} onClick={handleLogin}>
                    เข้าสู่ระบบ
                  </button>

                  <button
                    className={styles.registerBtn}
                    onClick={handleRegister}
                  >
                    สมัครสมาชิก
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      <div className={styles.announceBar}>
        <div className={styles.container}>
          <div className={styles.announceLabel}>ประกาศ:</div>
          <div className={styles.announceMarquee}>
            <Marquee variant="header" />
          </div>
        </div>
      </div>

      {isRegisterOpen && (
        <RegisterModal
          onClose={closeRegister}
          onSwitchToLogin={() => {
            closeRegister();
            onLoginClick && onLoginClick();
          }}
        />
      )}
    </header>
  );
});

Header.displayName = "Header";

export default Header;
